export default __webpack_public_path__ + "static/media/ser2-3.0dca37ee.jpg";